import React, { useEffect } from "react";
import { useCurrentTheme } from "../../utils/hooks";

/**
 * Synchronizuje klasę motywu (optimisTheme/defaultTheme) na body.
 * Dzięki temu style z @include theme() działają także w MUI Portal (Dialog, itp.),
 * które renderują treść poza głównym drzewem aplikacji.
 */
export const ThemeBodySync: React.FC = () => {
  const { themeName } = useCurrentTheme();

  useEffect(() => {
    if (typeof document === "undefined") {
      return;
    }
    document.body.classList.remove("optimisTheme", "defaultTheme");
    document.body.classList.add(themeName);
  }, [themeName]);

  return null;
};